import { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import "./css/styles.css";

export function Navbar() {
  const [navBar, setNavBar] = useState(false);

  const handleNavBar = () => {
    setNavBar(!navBar);
  };

  const navLinks = [
    // { path: "/winkelmandje", label: <img className="w-7 h-7" src={require("./images/basket.png")}  alt={""}/> },
    // { path: "/weekmenu", label: "Weekmenu" },
    { path: "/highteas", label: "High Teas" },
    // { path: "/order", label: "Bestellen"},
    { path: "/contact", label: "Contact" },
  ];

  return (
    <div className="flex justify-between items-center h-24 max-w-screen mx-auto 4-px bg-white border-b border-gray-200">
      
      {/* store logo and name */}
      <div className="flex items-center">
        <Link className="text-3xl font-bold pl-4" to="/">
          <img className="h-24 p-4" src={require("./images/smaeck.jpg")} alt="" />
        </Link>
        <h1>
          <Link className="title pl-4" to="/">
            Smaeck.
          </Link>
        </h1>
      </div>

      {/* navbar tabs pc */}
      <ul className="hidden md:flex">
        {navLinks.map((link) => (
          <li key={link.path} className="p-4">
            <Link to={link.path}>{link.label}</Link>
          </li>
        ))}
      </ul>

      {/* menu icon mobile */}

      <ul onClick={handleNavBar} className="block md:hidden pr-4">
        <li className="p-3">
          {navBar ? <AiOutlineClose size={25} /> : <AiOutlineMenu size={25} />}
        </li>
      </ul>

      {/* nav bar menu mobile */}
      <div
        className={
          navBar
            ? "fixed right-0 top-24 w-[40%] h-auto border-l border-b border-gray-200 bg-white"
            : "fixed left-[-100%]"
        }
      >
        <ul className="p-2">
          {navLinks.map((link) => (
            <li key={link.path} className="p-4">
              <Link to={link.path}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Navbar;